@if ({
  vendorReportingOverview: vendorReportingOverview$ | async,
  errorOverview: errorOverview$ | async,
  }; as type) {
  @if ( (searchFilters$ | async)) {
    <ng-cotainer>
      <!-- FILTERS AND IMPORT -->
      <div class="vendor-reporting-filter" id="vendor-reporting-filter">
        <form (ngSubmit)="onSubmit()" #searchForm="ngForm" autocomplete="off">
          <ng-container>
            <div class="form-group row">
              <label for="manufacturerNumber" class="col-md-2 col-form-label">{{
                'customVendorReporting.search.manufacturerNumber' | cxTranslate
              }}</label>
              <div class="col-md-2">
                <input type="text" id="manufacturerNumber" class="form-control" [(ngModel)]="filters.supplierProductCode"
                  name="manufacturerNumber" [value]="filters.supplierProductCode" />
                </div>
                <label for="ean" class="col-md-2 col-form-label">{{
                  'customVendorReporting.search.ean' | cxTranslate
                }}</label>
                <div class="col-md-2">
                  <input type="text" id="ean" class="form-control" [(ngModel)]="filters.ean" name="ean" [value]="filters.ean" />
                </div>
                @if (isRioEmployee) {
                  <label for="reportCategory" class="col-md-2 col-form-label">{{
                    'customVendorReporting.search.reportCategory' | cxTranslate
                  }}</label>
                  <ng-select id="reportCategory" class="col-md-2" [searchable]="false" [clearable]="false"
                    [(ngModel)]="filters.reportCategory" name="reportCategory" (change)="onReportCategoryChange()">
                    @if (!isRioEmployee) {
                      <ng-option value="">{{ 'customVendorReporting.search.all' | cxTranslate }}</ng-option>
                    }
                    @for (reportCategory of reportCategoryTypesList; track reportCategory) {
                      <ng-option [value]="reportCategory">{{
                        'customVendorReporting.reportCategory.' + reportCategory | cxTranslate
                      }}</ng-option>
                    }
                  </ng-select>
                }
              </div>
              <div class="form-group row">
                <label for="manufacturer" class="col-md-2 col-form-label">{{
                  'customVendorReporting.search.manufacturer' | cxTranslate
                }}</label>
                <ng-select id="manufacturer" class="col-xl-2" [searchable]="false" [clearable]="false" [(ngModel)]="filters.manufacturer"
                  name="manufacturer">
                  <ng-option value="">{{ 'customVendorReporting.search.all' | cxTranslate }}</ng-option>
                  @for (manufacturerMapping of (manufacturersList$ | async); track manufacturerMapping) {
                    <ng-option
                      [value]="manufacturerMapping">
                      <div>{{ manufacturerMapping }}</div>
                    </ng-option>
                  }
                </ng-select>
                <label for="reportTransferType" class="col-md-2 col-form-label">{{
                  'customVendorReporting.search.reportTransferType' | cxTranslate
                }}</label>
                <ng-select id="reportTransferType" class="col-xl-2" [searchable]="false" [clearable]="false"
                  [(ngModel)]="filters.reportTransferType" name="reportTransferType">
                  <ng-option value="">{{ 'customVendorReporting.search.all' | cxTranslate }}</ng-option>
                  @for (reportTransferType of reportTransferTypesList; track reportTransferType) {
                    <ng-option [value]="reportTransferType">{{
                      'customVendorReporting.reportTransferTypes.' + reportTransferType | cxTranslate
                    }}</ng-option>
                  }
                </ng-select>
                <label for="reportChannel" class="col-md-2 col-form-label">{{
                  'customVendorReporting.search.reportChannel' | cxTranslate
                }}</label>
                <ng-select id="reportChannel" class="col-xl-2" [searchable]="false" [clearable]="false"
                  [(ngModel)]="filters.reportChannel" name="reportChannel">
                  <ng-option value="">{{ 'customVendorReporting.search.all' | cxTranslate }}</ng-option>
                  @for (reportChannel of reportChannelList; track reportChannel) {
                    <ng-option [value]="reportChannel">{{
                      'customVendorReporting.reportChannelTypes.' + reportChannel | cxTranslate
                    }}</ng-option>
                  }
                </ng-select>
              </div>
              <div class="form-group row">
                <label for="reportTransferStatus" class="col-md-2 col-form-label">{{
                  'customVendorReporting.search.reportTransferStatus' | cxTranslate
                }}</label>
                <ng-select id="reportTransferStatus" class="col-xl-2" [searchable]="false" [clearable]="false"
                  [(ngModel)]="filters.reportTransferStatus" name="reportTransferStatus">
                  <ng-option value="">{{ 'customVendorReporting.search.all' | cxTranslate }}</ng-option>
                  @for (reportTransferStatus of reportTransferStatusesList; track reportTransferStatus) {
                    <ng-option [value]="reportTransferStatus">
                      <div>{{ 'customVendorReporting.reportTransferStatuses.' + reportTransferStatus | cxTranslate }}</div>
                    </ng-option>
                  }
                </ng-select>
                <label for="reportTransferPeriod" class="col-md-2 col-form-label">{{
                  'customVendorReporting.search.reportTransferPeriod' | cxTranslate
                }}</label>
                <div class="col-md-2">
                  <input type="text" id="reportTransferPeriod" class="form-control" [(ngModel)]="filters.reportTransferPeriod"
                    name="reportTransferPeriod" [value]="filters.reportTransferPeriod" />
                  </div>
                  @if (isRioEmployee) {
                    <label for="b2bUnit" class="col-md-2 col-form-label">{{
                      'customVendorReporting.search.b2bUnit' | cxTranslate
                    }}</label>
                    <div class="col-md-2">
                      <input type="text" id="b2bunit" class="form-control" [(ngModel)]="filters.b2bUnit" name="b2bUnit"
                        [value]="filters.b2bUnit" />
                      </div>
                    }
                  </div>
                  @if (isRioEmployee ) {
                    <!-- DashBoard filter area -->
                    <div class="form-group row">
                      <label for="productCode" class="col-md-2 col-form-label">{{
                        'customVendorReporting.search.productCode' | cxTranslate
                      }}</label>
                      <div class="col-md-2">
                        <input type="text" id="productCode" class="form-control" [(ngModel)]="filters.productCode" name="productCode"
                          [value]="filters.productCode" />
                        </div>
                        <label for="transferPeriodLabel" class="col-md-1 col-form-label">{{
                          'customVendorReporting.search.transferPeriodLabel' | cxTranslate
                        }}</label>
                        <label for="transferDateFrom" class="col-md-1 col-form-label">{{
                          'customVendorReporting.search.transferDateFrom' | cxTranslate
                        }}</label>
                        <div class="col-md-2">
                          <input type="date" id="transferDateFrom" class="form-control" name="transferDateFrom" [(value)]="filters.transferDateFrom"
                            [(ngModel)]="filters.transferDateFrom" max="{{filters.transferDateTo}}" (change)="validateTransferDateFrom()" />
                          </div>
                          <label for="transferDateTo" class="col-md-1 col-form-label">{{
                            'customVendorReporting.search.transferDateTo' | cxTranslate
                          }}</label>
                          <div class="col-md-2">
                            <input type="date" id="transferDateTo" class="form-control" name="transferDateTo" [(ngModel)]="filters.transferDateTo"
                              [(value)]="filters.transferDateTo" min="{{ filters.transferDateFrom }}" (change)="validateTransferDateTo()" />
                            </div>
                          </div>
                        } @else {
                          <div class="form-group row">
                            <label for="productCode" class="col-md-2 col-form-label">{{
                              'customVendorReporting.search.productCode' | cxTranslate
                            }}</label>
                            <div class="col-md-2">
                              <input type="text" id="productCode" class="form-control" [(ngModel)]="filters.productCode" name="productCode"
                                [value]="filters.productCode" />
                              </div>
                              <label  class="col-md-2 col-form-label">{{
                                'customVendorReporting.transferDate' | cxTranslate
                              }}</label>
                              <label for="transferDateFrom" class="col-md-1 col-form-label">{{
                                'customVendorReporting.search.transferDateFrom' | cxTranslate
                              }}</label>
                              <div class="col-md-2">
                                <input type="date" id="transferDateFrom" class="form-control" name="transferDateFrom" [(value)]="filters.transferDateFrom"
                                  [(ngModel)]="filters.transferDateFrom" max="{{filters.transferDateTo}}" (change)="validateTransferDateFrom()" />
                                </div>
                                <label for="transferDateTo" class="col-md-1 col-form-label">{{
                                  'customVendorReporting.search.transferDateTo' | cxTranslate
                                }}</label>
                                <div class="col-md-2">
                                  <input type="date" id="transferDateTo" class="form-control" name="transferDateTo" [(ngModel)]="filters.transferDateTo"
                                    [(value)]="filters.transferDateTo" min="{{ filters.transferDateFrom }}" (change)="validateTransferDateTo()" />
                                  </div>
                                </div>
                              }
                            </ng-container>
                            <div class="form-group row">
                              <div class="col-sm-3">
                                <button class="btn btn-secondary btn-block mb-3" type="submit">
                                  {{ 'customVendorReporting.buttons.search' | cxTranslate }}
                                </button>
                              </div>
                              <div class="col-sm-3">
                                <button class="btn btn-secondary btn-block mb-3" type="button" (click)="resetForm()">
                                  {{ 'customVendorReporting.buttons.reset' | cxTranslate }}
                                </button>
                              </div>
                              <div class="col-sm-6">
                                <button type="button" class="btn btn-secondary btn-block mb-6" type="button" (click)="openInstructions()">
                                  {{ 'customVendorReporting.buttons.instruction' | cxTranslate }}
                                </button>
                              </div>
                            </div>
                          </form>
                          @if (!isRioEmployee) {
                            <div class="import-container">
                              <hr>
                                <div class="import-header row">
                                  <div class="col-9">
                                    <p class="title"> {{ 'customVendorReporting.import.title' | cxTranslate }} </p>
                                    <p class="text"> {{ 'customVendorReporting.import.text' | cxTranslate }} </p>
                                  </div>
                                </div>
                                <div class="form-group row import-buttons">
                                  <div class="col-sm-2 import-extra-column">
                                    &nbsp;
                                  </div>
                                  <div class="col-md-4 col-sm-6">
                                    <div class="custom-file">
                                      <input type="file" class="custom-file-input" id="customCSVImport" (change)="onFileSelected($event)" (click)="$event.target.value=null">
                                      @if (!fileName) {
                                        <label class="custom-file-label" for="customCSVImport">
                                          {{'customVendorReporting.import.noFileSelected' | cxTranslate}}
                                        </label>
                                      }
                                      @if (fileName) {
                                        <label class="custom-file-label" for="customCSVImport">
                                          {{fileName}}
                                        </label>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-3 col-sm-6">
                                    <button class="btn btn-secondary btn-block mb-3" type="button" (click) ="importFile()">
                                      {{ 'customVendorReporting.buttons.import' | cxTranslate }}
                                    </button>
                                  </div>
                                </div>
                                <hr>
                                </div>
                              }
                            </div>
                            <!-- SORT -->
                            <div class="vendor-reporting-sort">
                              <div class="form-group row">
                                <label for="vendorReportingSorting" class="sort-options-label col-sm-12 col-form-label">{{
                                  'customVendorReporting.sortOptions.label' | cxTranslate
                                }}</label>
                                <ng-select id="sortOptions" class="sort-options-dropdown col-sm-12 col-xl-3" [searchable]="false" [clearable]="false"
                                  (change)="onChangeSort()" [(ngModel)]="selectedSortOption">
                                  @for (sort of sortOptions; track sort) {
                                    <ng-option [value]="sort">{{
                                      'customVendorReporting.sortOptions.' + sort | cxTranslate
                                    }}</ng-option>
                                  }
                                </ng-select>
                                <label for="sortDirections" class="sort-directions-label col-sm-12 col-form-label">{{
                                  'customVendorReporting.sortDirections' | cxTranslate
                                }}</label>
                                <div class="sort-direction-btn col-sm-12 col-form-label">
                                  <div class="form-check">
                                    <input class="form-check-input" type="radio" name="sortDirection" id="sortDirectionDesc" value="desc"
                                      ng-control="sortDirection" [(ngModel)]="sortDirection" (change)="onChangeSort()" />
                                      <label class="form-check-label" for="sortDirectionDesc">
                                        {{ 'customVendorReporting.sortDirection.desc' | cxTranslate }}
                                      </label>
                                    </div>
                                  </div>
                                  <div class="sort-direction-btn col-sm-12 col-form-label">
                                    <div class="form-check">
                                      <input class="form-check-input" type="radio" name="sortDirection" id="sortDirectionAsc" value="asc" ng-control="sortDirection"
                                        [(ngModel)]="sortDirection" (change)="onChangeSort()" />
                                        <label class="form-check-label" for="sortDirectionAsc">
                                          {{ 'customVendorReporting.sortDirection.asc' | cxTranslate }}
                                        </label>
                                      </div>
                                    </div>
                                    <div class="timestamp-check-box col-sm-12 col col-form-label">
                                      <div class="form-check">
                                        <input type="checkbox" id="showSuccessfullyTransferred" class="form-control" name="showSuccessfullyTransferred" [(ngModel)]="showSuccessfullyTransferred"
                                          (change)="fireFilterSuccessfullyTransferred()"/>
                                          <label for="showSuccessfullyTransferred" class="form-check-label">{{
                                            'customVendorReporting.search.showTransferredOnly' | cxTranslate
                                          }}</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </ng-cotainer>
                              }
                              <!-- TABLE -->
                              @if ((vendorReportingOverview || errorOverview) && ((isFilteringrSuccessfullyTransferred$ |async) === false)) {
                                <!-- TABLE -->
                                <table class="table vendor-reporting-table" aria-describedby="vendor-reporting-table">
                                  <thead class="vendor-reporting-header">
                                    @if (isRioEmployee) {
                                      <th scope="col" class="b2bUnit">
                                        {{ 'customVendorReporting.b2bUnit' | cxTranslate }}
                                      </th>
                                      <th scope="col" class="partnerID">
                                        {{ 'customVendorReporting.partnerID' | cxTranslate }}
                                      </th>
                                    }
                                    <th scope="col" class="manufacturer">
                                      {{ 'customVendorReporting.manufacturer' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="reportTransferType">
                                      {{ 'customVendorReporting.reportTransferType' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="reportChannel">
                                      {{ 'customVendorReporting.reportChannel' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="reportTransferPeriod">
                                      {{ 'customVendorReporting.reportTransferPeriod' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="transferDate">
                                      {{ 'customVendorReporting.transferDate' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="dataCount">
                                      {{ 'customVendorReporting.dataCount' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="reportTransferStatus">
                                      {{ 'customVendorReporting.reportTransferStatus' | cxTranslate }}
                                    </th>
                                    <th scope="col" class="timestamp">
                                      {{ 'customVendorReporting.timestamp' | cxTranslate }}
                                    </th>
                                  </thead>
                                  <tbody>
                                    @if (vendorReportTransferDataList.length === 0) {
                                      <tr>
                                        <td colspan="10">
                                          {{ 'customVendorReporting.emptyTable' | cxTranslate }}
                                        </td>
                                      </tr>
                                    }
                                    @for (vendorReportTransferData of vendorReportTransferDataList; track vendorReportTransferData) {
                                      <tr (click)="openDetails(vendorReportTransferData)">
                                        @if (isRioEmployee) {
                                          <td class="manufacturer">
                                            <div class="d-md-none vendor-reporting-label">
                                              {{ 'customVendorReporting.b2bUnit' | cxTranslate }}
                                            </div>
                                            <div class="vendor-reporting-value">
                                              <a class="vendor-reporting-value">
                                              {{ vendorReportTransferData?.b2bUnit}}</a>
                                            </div>
                                          </td>
                                          <td class="manufacturer">
                                            <div class="d-md-none vendor-reporting-label">
                                              {{ 'customVendorReporting.partnerID' | cxTranslate }}
                                            </div>
                                            <div class="vendor-reporting-value">
                                              <a class="vendor-reporting-value">
                                              {{ vendorReportTransferData?.partnerId}}</a>
                                            </div>
                                          </td>
                                        }
                                        <td class="manufacturer">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.manufacturer' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ vendorReportTransferData?.manufacturer}}</a>
                                          </div>
                                        </td>
                                        <td class="reportTransferType">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.reportTransferType' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ 'customVendorReporting.reportTransferTypes.' + vendorReportTransferData?.reportTransferType | cxTranslate }}</a>
                                          </div>
                                        </td>
                                        <td class="reportChannel">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.reportChannel' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ 'customVendorReporting.reportChannelTypes.' + vendorReportTransferData?.reportChannel | cxTranslate}}</a>
                                          </div>
                                        </td>
                                        <td class="reportTransferPeriod">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.reportTransferPeriod' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ vendorReportTransferData?.reportTransferPeriod}}</a>
                                          </div>
                                        </td>
                                        <td class="transferDate">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.transferDate' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ vendorReportTransferData?.transferDate | cxDate }}</a>
                                          </div>
                                        </td>
                                        <td class="dataCount">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.dataCount' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ vendorReportTransferData?.dataCount}}</a>
                                          </div>
                                        </td>
                                        <td class="reportTransferStatus">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.reportTransferStatus' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value"
                                              ngClass="status-{{getReportTransferStatusColor(reportTransferStatusEnum[vendorReportTransferData?.reportTransferStatus])}}">
                                              {{ 'customVendorReporting.reportTransferStatuses.' + vendorReportTransferData?.reportTransferStatus |
                                            cxTranslate}}</a>
                                          </div>
                                        </td>
                                        <td class="timestamp">
                                          <div class="d-md-none vendor-reporting-label">
                                            {{ 'customVendorReporting.timestamp' | cxTranslate }}
                                          </div>
                                          <div class="vendor-reporting-value">
                                            <a class="vendor-reporting-value">
                                            {{ vendorReportTransferData?.timeStamp | cxDate:'dd.MM.YYYY hh:mm' }}</a>
                                          </div>
                                        </td>
                                      </tr>
                                    }
                                  </tbody>
                                  <!--  -->
                                </table>
                              } @else {
                                <cx-spinner></cx-spinner>
                              }
                            }
